<template>
  <div class="wlx-alse-activity-wrapper">
    <div class="wl-certification-content-none">
      <div class="authen-hade-title clearfix">
        <h3 class="h3-text-title">
          <span>专题活动</span>
        </h3>
        <div class="authen-hade-crumbs">
          <i class="wl-icon-zhuye1"></i>
          <span>当前位置：</span>
          <span @click="goHome">网站首页</span>
          <span>></span>
          <span>其他活动</span>
        </div>
      </div>
      <div class="alse-activity-main clearfix">
        <div class="alse-activity-li fl" @click="enterApplyTea">
          <div class="alse-activity-img">
            <img :src="activityimgs1" style="width:100%;height:100%">
          </div>
          <p class="activity-title">1＋X试点申报学校基本情况统计</p>
        </div>
      </div>
    </div>

    <div class="ph-wl-certification-content">
      <div class="ph-authen-head-info clearfix">
        <div class="ph-head-menu">
          <i class="wl-icon-zhuye1" @click="goHome">
            <span>首页</span>
          </i>
          <span>></span>
          <span>专题活动</span>
        </div>
      </div>

      <div class="ph-alse-activity-main clearfix">
        <div class="fl ph-alse-activity-info" @click="enterApplyTea">
          <div class="ph-alse-activity-img">
            <img class="ph-activity-list-img" :src="activityimgs1">
          </div>
          <p class="ph-activity-title">1＋X试点申报学校基本情况统计</p>
        </div>
      </div>
    </div>

    <!-- 登录 -->
    <el-dialog
      :show-close="true"
      :visible.sync="scanVisible"
      top="12%"
      :close-on-click-modal="false"
      width="500px"
      class="unified-login-dialog-style"
    >
      <login></login>
      <p @click="enterRegister" class="p-enter-register">去注册</p>
    </el-dialog>
  </div>
</template>

<script>
import login from "components/login/login.vue";
export default {
  data() {
    return {
      scanVisible: false,
      isTab: 1,
      back: require("assets/images/bg-jieshao.png"),
      TeaAuthenticaList: [],
      activityimgs1: require("assets/images/activity01.png"),
      activityimgs2: require("assets/images/activity02.png"),
      activityimgs3: require("assets/images/activity03.png")
    };
  },
  components: {
    login
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val.code > 0) {
          this.scanVisible = false;
        }
      }
    },
    deep: true
  },
  created() {},
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    enterApplyTea() {
      this.$router.push({
        name: "basicStatistics"
      });
    },
    enterTeaApply(type) {
      if (this.userInfo.code < 0) {
        this.scanVisible = true;
      }
      if (this.userInfo.code > 0 && this.userInfo.userType != 2) {
        this.$message({
          message: "只有老师才能报名",
          type: "warning"
        });
      }
      if (this.userInfo.code > 0 && this.userInfo.userType == 2) {
        if (type == 1 && this.userInfo.isLecturer == 2) {
          this.$message({
            message: "您已经是一名出色的培训师啦!!",
            type: "warning"
          });
        } else if (type == 2 && this.userInfo.isAppraiser == 2) {
          this.$message({
            message: "您已经是一名出色的考评员啦!!",
            type: "warning"
          });
        } else {
          this.$router.push({
            name: "applyTable",
            params: {
              userType: String(type)
            }
          });
        }
      }
    },
    goLogin() {
      this.$router.push({
        name: "Login"
      });
    },
    enterRegister() {
      this.scanVisible = false;
      this.$router.push({
        name: "register"
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-alse-activity-wrapper {
  .ph-wl-certification-content {
    display: none;
  }
  .apply-activity-li {
    position: relative;
    margin: 24px 24px 0 0;
    width: 340px;
    height: 180px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    background: #fd7799;
    text-align: center;
    font-size: 20px;
    .p-appli-title {
      padding-top: 60px;
    }
  }
  .alse-activity-main {
    .alse-activity-li {
      width: 284px;
      margin-right: 48px;
      margin-top: 38px;
      cursor: pointer;
    }
    .alse-activity-li:nth-child(3n) {
      margin-right: 0px;
    }
    .alse-activity-img {
      height: 168px;
    }
    .activity-title {
      text-align: center;
      margin-top: 18px;
      font-size: 16px;
      color: #333;
    }
  }
}
@media only screen and (max-width: 700px) and (min-width: 320px) {
  .wl-certification-content-none {
    display: none;
  }
  .wl-project-introduction .wl-certification-content {
    width: auto;
    .wlx-alse-activity-wrapper {
      .ph-wl-certification-content {
        display: block;
        width: 100%;
      }
      .ph-authen-head-info {
        width: 100%;
      }
      .ph-head-menu {
        color: #666;
        padding: 0px 20px;
        background: #f5f7fb;
        height: 40px;
        line-height: 40px;
      }
      span {
        margin: 0 3px;
      }

      .ph-alse-activity-main {
        padding: 0 20px;
        margin: 0 auto;
      }
      .ph-authen-hade-title {
        font-size: 14px;
        margin-top: 10px;
        color: #297efd;
        font-weight: bold;
        cursor: pointer;
        margin-bottom: -1px;
        padding-bottom: 10px;
        border-bottom: 1px solid #297efd;
      }
      .ph-authen-hade-crumbs {
        font-size: 12px;
        padding: 5px;
        margin-top: 10px;
      }
      .ph-alse-activity-main {
        margin-top: 10px;
      }
      .ph-alse-activity-info {
        width: 48%;
      }
      .ph-alse-activity-info:nth-child(2n) {
        float: right;
      }
      .ph-alse-activity-img {
        width: 100%;
      }
      .ph-activity-list-img {
        width: 100%;
      }
      .ph-activity-title {
        text-align: center;
        font-size: 14px;
        margin-top: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>



